import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { UserDataService } from "../services/user-data.service";
import { RolesEnum } from "../enums/RolesEnum";
import { SnackService } from "../services/snack.service";
import { ERROR_NOT_PERMISSION } from "../constants/constants";
import { ViewPath } from "../constants/ViewPath";
import { PermissionsEnum } from "../enums/PermissionsEnum";

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate{

  userDataS = inject(UserDataService);
  snackS    = inject(SnackService);
  router    = inject(Router);

  canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      /** Get Eina main user data */
      this.userDataS.getUserData().then(res => {
        if (!res) { resolve(false); }
        else {
          let roles: RolesEnum[] | undefined;
          let permissions: PermissionsEnum[] | undefined;
          console.log("RoleGuard.canActivate.next:", next);
          console.log("RoleGuard.canActivate.next.data:", next.data);
          console.log("eooo", res.user);
          if (next.data && next.data['roles']) {
            roles = next.data['roles'];
          }
          if (roles == undefined || !roles.length) { resolve(true); }
          else {
            console.log("haha");
            let hasPermission = roles.includes(RolesEnum.CUSTOMER_SERVICE);
            if (!hasPermission) {
              this.snackS.show(ERROR_NOT_PERMISSION);
              let url = ViewPath.pageNotFound.path;
              this.router.navigate([url]);
            }
            resolve(hasPermission);
          }
        }
      })
    }
    )
  }

  private hasRequiredPermissions(userPermissions: Array<PermissionsEnum>, routePermissions: Array<PermissionsEnum>) : boolean
  {
    return true;
  }
}